import { makeStyles } from '@material-ui/styles'
import { dark50, dark75, green } from 'lib/Colors'

export const useStyle = makeStyles(
	() => ({
		root: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			marginBottom: 8,
			backgroundColor: 'transparent',
			width: '100%',
			position: 'relative',
		},
		selectIndicator: {
			width: 4,
			backgroundColor: green,
			height: 72,
			position: 'absolute',
			left: 0,
			borderTopLeftRadius: 6,
			borderBottomLeftRadius: 6,
			zIndex: 2,
		},
		imageRow: {
			flex: 1,
			zIndex: 1,
			height: 72,
			borderRadius: 6,
			backgroundColor: '#fff',
			padding: 16,
			boxShadow: '0px 0px 1px rgba(41, 50, 65, 0.25)',
			cursor: 'pointer',
			transition: 'all 0.2s',
			'&:hover': {
				boxShadow: '0px 2px 4px rgba(41, 50, 65, 0.15)',
				borderColor: green,
			},
		},
		imageRowSelected: {
			border: `2px solid ${green}`,
			backgroundColor: '#f0f9ff',
		},
		imageRowColumn: {
			paddingLeft: 16,
			flexDirection: 'column',
		},
		imageRowLastColumn: {
			paddingLeft: 16,
			flexDirection: 'column',
		},
		accentText: {
			color: dark75,
			fontWeight: 600,
		},
		imageID: {
			paddingRight: 2,
			maxWidth: 270,
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
		},
		columnTitle: {
			color: dark50,
		},
		thumbnail: {
			overflow: 'hidden',
			paddingTop: 0,
			width: 40,
			height: 40,
			borderRadius: 4,
			objectFit: 'cover',
			'& img': {
				maxHeight: 150,
				minHeight: '100%',
			},
		},
		thumbnailOverlay: {
			borderRadius: 4,
			overflow: 'hidden',
		},
		placeholder: {
			borderRadius: 4,
			backgroundColor: '#f0f0f0',
			width: 40,
			height: 40,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
	}),
	{ index: 1 },
)

